// Tiny presentational primitives shared across SourceDetailPage's
// extracted components. Kept intentionally trivial — anything that
// grows logic moves to its own file.
//
// The pages/SourceDetailPage.tsx split (Apr 2026) extracts these first
// so dialog / tab / row components downstream can `import { Label, Inp,
// inpStyle } from '../common/atoms'` without dragging the whole 6.8k-line
// page along.

import React from 'react';

/** Section label rendered above an input/control. Mono uppercase, dim. */
export function Label({ children }: { children: React.ReactNode }) {
  return <div style={{ fontSize: 11, fontFamily: 'var(--mono)', color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4, marginTop: 12 }}>{children}</div>;
}

/** Plain text input wired through the same border/spacing style as
 *  inpStyle. Use when an `<input>` is enough — for selects, datetime,
 *  textarea, just spread {...inpStyle}. */
export function Inp({ value, onChange, placeholder }: { value: string; onChange: (v: string) => void; placeholder?: string }) {
  return <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={inpStyle} />;
}

/** Shared style for inputs / selects / textareas inside dialogs and
 *  forms. Keeps width 100%, mono-friendly padding, neutral border. */
export const inpStyle: React.CSSProperties = {
  width: '100%', boxSizing: 'border-box',
  padding: '8px 12px', fontSize: 13, fontFamily: 'var(--ui)',
  border: '1px solid var(--line)', borderRadius: 6, outline: 'none',
};
